/* eslint-disable react/no-unused-prop-types */
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { ServerContext } from '@bingads-webui-campaign-react/server-context';
import { DetailsList, SelectionMode } from '@bingads-webui-react/fabric-control';
import { DetailsRow } from '@fluentui/react';
import { Pagination } from '@bingads-webui-grid/campaign-details-list';
import { generateColumn, getAllColumns } from './generate-column';

const cropWithPage = (pageSize, pageNumber, data) => {
  const min = (pageNumber - 1) * pageSize;
  const max = pageNumber * pageSize;
  return data.slice(min, max);
};

export const TargetDetailList = (props) => {
  const i18n = useContext(I18nContext);
  const serverContext = useContext(ServerContext);
  const {
    data,
    setData,
    isDirty,
    setIsDirty,
    enablePagination,
    pageSize,
    pageNumber,
    setPageSize,
    setPageNumber,
    hideWhenEmpty,
    minBid,
    maxBid,
    extraBid,
    onlyExtra,
    validateParams,
    patchTargetsApiErrMsg,
  } = props;

  const handleRemove = (index) => {
    const currentLevelSettings = [...data.currentLevelSettings];
    const item = { ...currentLevelSettings[index] };
    if (item.Id) {
      item.Status = 'Deleted';
      currentLevelSettings[index] = item;
    } else {
      currentLevelSettings.splice(index, 1);
    }
    setData({ ...data, currentLevelSettings, remove: true });
    if (validateParams) {
      patchTargetsApiErrMsg(validateParams.targetName, []);
    }
  };

  const handleRemoveAll = () => {
    const currentLevelSettings = [...data.currentLevelSettings];
    const tempCurrentLevelSettings = [];
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < currentLevelSettings.length; i++) {
      const item = currentLevelSettings[i];
      if (item.Id) {
        tempCurrentLevelSettings.push({
          ...item,
          Status: 'Deleted',
        });
      }
    }
    setData({ ...data, currentLevelSettings: tempCurrentLevelSettings });
    if (validateParams) {
      validateParams.patchErrMsg(validateParams.targetName, '');
      patchTargetsApiErrMsg(validateParams.targetName, []);
    }
  };

  const renderItemColumn = (item, index, column) => generateColumn({
    item,
    index,
    column,
    i18n,
    serverContext,
    isDirty,
    setIsDirty,
    handleRemove,
    props,
    hideWhenEmpty,
  });

  const renderItemRow = (row) => {
    const customStyles = {};
    if (row) {
      if (row.item.Status === 'Deleted') {
        customStyles.root = { display: 'none' };
      }
      return <DetailsRow {...row} styles={customStyles} />;
    }
    return null;
  };

  let itemsSetting = data.currentLevelSettings;
  if (data.useParentLevel) {
    itemsSetting = data.parentLevelSettings;
  }

  const items = enablePagination ? cropWithPage(pageSize, pageNumber, itemsSetting) : itemsSetting;
  if (hideWhenEmpty && items.length === 0) {
    return null;
  }

  return (
    <React.Fragment>
      <DetailsList
        className="criterion-target-table"
        selectionMode={SelectionMode.none}
        items={items}
        columns={getAllColumns({
          i18n,
          props,
          setIsDirty,
          handleRemoveAll,
          minBid,
          maxBid,
          extraBid,
          onlyExtra,
        })}
        onRenderItemColumn={renderItemColumn}
        onRenderRow={renderItemRow}
      />
      {enablePagination &&
        <div className="pagination-control">
          <Pagination
            pageNumber={pageNumber}
            onPageChange={number => setPageNumber(number)}
            pageSize={pageSize}
            total={itemsSetting.length}
            onPageSizeChange={size => setPageSize(size)}
          />
        </div>}
    </React.Fragment>
  );
};

TargetDetailList.propTypes = {
  data: PropTypes.shape({}).isRequired,
  setData: PropTypes.func,
  columns: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  isDirty: PropTypes.shape({}).isRequired,
  setIsDirty: PropTypes.func.isRequired,
  showAddBtn: PropTypes.bool,
  handleChangeInput: PropTypes.func.isRequired,
  getFieldErrorMsg: PropTypes.func,
  enablePagination: PropTypes.bool,
  setPageSize: PropTypes.func.isRequired,
  setPageNumber: PropTypes.func.isRequired,
  pageSize: PropTypes.number.isRequired,
  pageNumber: PropTypes.number.isRequired,
  minBid: PropTypes.number,
  maxBid: PropTypes.number,
  extraBid: PropTypes.arrayOf(PropTypes.number),
  onlyExtra: PropTypes.bool,
  hideWhenEmpty: PropTypes.bool,
  validateParams: PropTypes.shape({}).isRequired,
  patchTargetsApiErrMsg: PropTypes.func,
};

TargetDetailList.defaultProps = {
  setData() { },
  getFieldErrorMsg() { },
  showAddBtn: false,
  enablePagination: false,
  hideWhenEmpty: false,
  minBid: undefined,
  maxBid: undefined,
  onlyExtra: false,
  extraBid: [],
  patchTargetsApiErrMsg() { },
};
